export {ProductFeatureAutoItem} from './lib/product-feature-auto-item';